import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {DraftMessageModel} from '../../../models/api/messageModel';
import {findPanelSequence} from '../../../services/panels';
import {ThunkAction} from '../../appThunk';
import {CellsContext} from '../cells/context/cellsContext';
import {PanelActionPayload, setPanelAction} from '../panelsActions';
import {getFirstAppPanelId, getPanels} from '../panelsSelectors';
import {ComposerPanelId, makeComposerPanelId, PanelTypesEnum} from '../panelStateBase';
import {ComposerPanelState} from './composerPanelState';

/*
 * Type enum.
 */

export enum ComposerPanelActionsEnum {
  FORCE_COMPOSER_POPOUT = '@@panels/composer/FORCE_COMPOSER_POPOUT',
}

/*
 * Types.
 */

interface ForceComposerPopoutAction extends ActionWithPayload<PanelActionPayload<ComposerPanelId>> {
  type: ComposerPanelActionsEnum.FORCE_COMPOSER_POPOUT;
}

/*
 * Action creators.
 */

interface PopoutComposerOptions {
  cellsContext?: CellsContext;
  shouldForcePopout?: boolean;
  shouldAttachExternalResources?: boolean;
}

export function popoutComposerAction(draftUid: string, options: PopoutComposerOptions = {}): ThunkAction {
  return (dispatch, getState) => {
    const popupPanelId = makeComposerPanelId();
    const popupAppPanelId = getFirstAppPanelId(getState());
    const composerPanelState: ComposerPanelState = {
      id: popupPanelId,
      type: PanelTypesEnum.COMPOSER,
      sequence: findPanelSequence(),
      cellsContext: options.cellsContext,
      messageUid: draftUid,
      popupAppPanelId,
      shouldForcePopout: Boolean(options.shouldForcePopout),
      isStandalone: false,
      shouldAttachExternalResources: Boolean(options.shouldAttachExternalResources),
    };
    dispatch(setPanelAction(composerPanelState));
  };
}

export function navigateComposerAction(
  panelId: ComposerPanelId,
  createDraftAction: ThunkAction<DraftMessageModel>,
): ThunkAction {
  return (dispatch, getState) => {
    // Avoid navigating an existing composer.
    // TODO: Find a way to avoid this dependent state update.
    const panels = getPanels(getState());
    const panel = panels[panelId];
    if (panel) {
      return;
    }

    const draft = dispatch(createDraftAction);
    const composerPanelState: ComposerPanelState = {
      id: panelId,
      type: PanelTypesEnum.COMPOSER,
      sequence: findPanelSequence(),
      cellsContext: undefined,
      messageUid: draft.uid,
      isStandalone: true,
    };
    dispatch(setPanelAction(composerPanelState));
  };
}

export function forceComposerPopoutAction(panelId: ComposerPanelId): ForceComposerPopoutAction {
  return {
    type: ComposerPanelActionsEnum.FORCE_COMPOSER_POPOUT,
    payload: {panelId},
  };
}

/*
 * Union type.
 */

export type ComposerPanelAction = ForceComposerPopoutAction;
